import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore, REHYDRATE, PERSIST } from 'redux-persist'
import authMiddleware from './modules/auth/middleware'
import { createMigrate } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import migrations from './migrations'
import { reducer } from './reducer'
import { transformer as dashboardTransformer } from './modules/dashboard/transformer'
import { transformer as adminDashboardTransformer } from './modules/adminDashboard/transformer'
import { transformer as templateTransformer } from './modules/template/transformer'
import { transformer as companyCardsTransformer } from './modules/companyCards/transformer'
import { transformer as companyPaymentsTransformer } from './modules/companyPayments/transformer'
import { transformer as companyPlanningRecordLettersTransformer } from './modules/companyPlanningRecordLetters/transformer'
import { transformer as companyPlanningRecordTransformer } from './modules/companyPlanningRecord/transformer'
import { transformer as planningRecordsTransformer } from './modules/planningRecords/transformer'
import { transformer as planningRecordTransformer } from './modules/planningRecord/transformer'
import { transformer as deadLetterEventsTransformer } from './modules/deadLetterEvents/transformer'
import { transformer as templatesPendingReviewTransformer } from './modules/templatesPendingReivew/transformer'

const persistedReducer = persistReducer(
  {
    key: 'root',
    storage,
    migrate: createMigrate(migrations, { debug: false }),
    version: 2,
    blacklist: ['planningRecords'],
    transforms: [
      dashboardTransformer,
      adminDashboardTransformer,
      templateTransformer,
      templatesPendingReviewTransformer,
      companyCardsTransformer,
      companyPaymentsTransformer,
      companyPlanningRecordLettersTransformer,
      companyPlanningRecordTransformer,
      planningRecordsTransformer,
      planningRecordTransformer,
      deadLetterEventsTransformer,
    ],
  },
  reducer,
)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: false,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [REHYDRATE, PERSIST],
        ignoredActionPaths: [
          'payload.unsubscribe',
          'payload.dashboardData.unsubscribe',
          'payload.companyRankingData.unsubscribe',
          'payload.companyInfoData.unsubscribe',
          'payload.pendingDeadLetterCounterData.unsubscribe',
        ],
      },
    }).concat([authMiddleware.logoutMiddleware])
  },
})

export const persistor = persistStore(store, {}, () => {
  persistor.persist()
  store.dispatch({ type: 'persist/REHYDRATE_COMPLETE' })
})
